var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.top3
    ? _c(
        "ul",
        { staticClass: "list_rank_top" },
        _vm._l(_vm.itemList, function (item, index) {
          return _c(
            "RankTop3Item",
            _vm._b({ key: "rank-top3-" + index }, "RankTop3Item", item, false)
          )
        }),
        1
      )
    : _c(
        "ul",
        { staticClass: "list_rank" },
        _vm._l(_vm.itemList, function (item, index) {
          return _c(
            "RankNormalItem",
            _vm._b(
              { key: "rank-normal-" + index },
              "RankNormalItem",
              item,
              false
            )
          )
        }),
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }